import React from 'react'

export const LandingPageLogo = (): React.JSX.Element => {
    return (
        <div className={'w-full h-[106px] bg-secondary lg:bg-transparent flex flex-col justify-center items-center'}>
            <img src={'/assets/logo.svg'} alt={''} className={''} />
        </div>
    )
}
